<template>
  <div
    class="row intersectionLocation"
    v-on="$listeners"
    :class="{ intersectionLocation__selected: isPicked }"
  >
    <h4 class="col-md-2 intersectionLocation__title">
      <input
        class="intersectionLocation__radio"
        type="radio"
        name="address"
        :checked="isPicked"
        @change="$emit('click')"
      />
      交叉路查詢:
    </h4>
    <div class="col-md-2">
      <CountySelect
        class="intersectionLocation__countySelect"
        @change-county="getCountryCode"
      />
    </div>
    <input
      type="text"
      v-model="road"
      class="intersectionLocation__inputField col-md-3"
      @change="searchCrossRoad()"
    />
    <div class="col-md-3">
      <select
        class="intersectionLocation__select"
        v-model="intersectionSelected"
        @change="selectCrossRoad()"
      >
        <option disabled :value="-1">請選擇</option>
        <option
          v-for="(road, index) in intersectionRoads.roadArray"
          :key="index"
          :value="index"
        >
          {{
            '(' +
            road.town +
            ')' +
            road.city +
            road.road +
            '與' +
            road.intersection +
            '交叉路口'
          }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import API from '@/assets/js/libs/API'
import CountySelect from '@/components/tool/CountrySelect'
export default {
  props: {
    isPicked: Boolean,
  },
  components: {
    CountySelect,
  },
  data() {
    return {
      intersectionSelected: '',
      road: '',
      countryCode: '',
      // 交叉路口參數
      intersectionRoads: {
        roadArray: [],
        areaArray: [], // TODO: 可能沒在用了
        townIDArray: [], // TODO: 可能沒在用了
      },
    }
  },
  methods: {
    getCountryCode(country) {
      this.countryCode = country.value
    },
    searchCrossRoad() {
      const { road } = this
      // console.log('=======>',road.replace(/[ ]/g, '+'))
      // console.log(this.countryCode)
      API.get(
        `intersectionInfo/?key=${road.replace(
          /[ ]/g,
          '+',
        )}&county_number=${parseInt(this.countryCode)}`,
      )
        .then((res) => {
          // console.log(res)
          this.intersectionSelected = -1
          this.intersectionRoads.roadArray = res.result.intersectionInfo
        })
        .catch((err) => {
          // this.loader.hide()
          console.log('searchLandmark', err)
        })
    },
    selectCrossRoad() {
      console.log('selected====>', this.intersectionSelected)

      if (this.intersectionSelected === '') return

      // console.log(this.intersectionRoads.roadArray[this.intersectionSelected].Gps.coordinates)
      let lat =
        this.intersectionRoads.roadArray[this.intersectionSelected].Gps
          .coordinates[1]
      let lng =
        this.intersectionRoads.roadArray[this.intersectionSelected].Gps
          .coordinates[0]
      let intersection =
        '(' +
        this.intersectionRoads.roadArray[this.intersectionSelected].town +
        ')' +
        this.intersectionRoads.roadArray[this.intersectionSelected].city +
        this.intersectionRoads.roadArray[this.intersectionSelected].road +
        '||' +
        this.intersectionRoads.roadArray[this.intersectionSelected].intersection

      const value = {
        latitude: lat,
        longitude: lng,
        address: intersection,
      }

      this.$emit('update-location', value)
    },
    resetState() {
      this.road = ''
      this.intersectionSelected = -1
      this.intersectionRoads.roadArray = []
    },
  },
}
</script>

<style lang="scss" scoped>
.intersectionLocation {
  &__selected {
    background-color: #ffffb3;
  }

  &__title {
    font-size: 18px;
    color: black;
    margin: 0;
    margin-left: 15px;
    height: 36px;
    line-height: 36px;
    max-width: 247.15px;
  }

  &__radio {
    margin: 0;
    height: 36px;
    vertical-align: top;
  }

  &__countySelect {
    height: 36px;
  }

  &__inputField {
    height: 36px;
    padding: 6px 12px;
    font-size: 16px;
    color: #555;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  &__select {
    width: 100%;
    height: 36px;
    padding: 6px 12px;
    font-size: 16px;
    color: #555;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/mixins/PhoneHail/IntersectionLocation.vue